"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../../../../../common/js/BaseComponent");
var splide_1 = require("@splidejs/splide");
var loadGoogleMapsApi = require("load-google-maps-api");
var StoreDetail = /** @class */ (function (_super) {
    __extends(StoreDetail, _super);
    function StoreDetail($view) {
        var _this = _super.call(this, $view) || this;
        _this.$mapPreview = _this.$view.find("#map");
        _this.$mapStreetViewPreview = _this.$view.find("#map-street-view");
        _this.key = _this.$mapPreview.data("key");
        _this.lat = _this.$mapPreview.data("lat");
        _this.lng = _this.$mapPreview.data("lng");
        _this.bind();
        if ($('#carouselReviews-2').length !== 0) {
            _this.initSlideReviews();
        }
        return _this;
    }
    StoreDetail.prototype.initSlideReviews = function () {
        var splideReviews = new splide_1.default('#carouselReviews-2', {
            type: 'loop',
            perPage: 3,
            gap: '2rem',
            perMove: 1,
            pagination: false,
            drag: true,
            breakpoints: {
                767: {
                    perPage: 1,
                },
            }
        });
        splideReviews.mount();
    };
    StoreDetail.prototype.bind = function () {
        var _this = this;
        loadGoogleMapsApi({ key: this.key })
            .then(function (googleMaps) {
            // Carte
            _this.mapStreetView = new googleMaps.Map(_this.$mapStreetViewPreview[0], {
                center: { lat: _this.lat, lng: _this.lng },
                zoom: 18,
                streetViewControl: true,
                mapTypeControl: false,
                fullscreenControl: true,
            });
            var pos = {
                lat: _this.lat,
                lng: _this.lng,
            };
            //@ts-ignore
            var markerStreetView = new google.maps.Marker({
                //@ts-ignore
                map: _this.mapStreetView,
                position: pos
            });
            _this.geocoder = new google.maps.Geocoder();
            // Icon
            _this.markerIcon = {
                url: "/images/map-marker.png",
                scaledSize: new google.maps.Size(27, 36),
            };
            _this.infowindow = new google.maps.InfoWindow();
        })
            .catch(function (error) {
            console.error(error);
        });
        loadGoogleMapsApi({ key: this.key })
            .then(function (googleMaps) {
            // Carte
            _this.map = new googleMaps.Map(_this.$mapPreview[0], {
                center: { lat: _this.lat, lng: _this.lng },
                zoom: 13,
                streetViewControl: false,
                mapTypeControl: false,
                fullscreenControl: false,
            });
            var pos = {
                lat: _this.lat,
                lng: _this.lng,
            };
            //@ts-ignore
            var marker = new google.maps.Marker({
                //@ts-ignore
                map: _this.map,
                position: pos
            });
            _this.geocoder = new google.maps.Geocoder();
            // Icon
            _this.markerIcon = {
                url: "/images/map-marker.png",
                scaledSize: new google.maps.Size(27, 36),
            };
            _this.infowindow = new google.maps.InfoWindow();
        })
            .catch(function (error) {
            console.error(error);
        });
    };
    return StoreDetail;
}(BaseComponent_1.default));
exports.default = StoreDetail;
